/**
 * AIHelperPrompt — DEPRECATED.
 *
 * The confirmation prompt is now shown inline within AIHelperPanel.
 * This component is kept as a no-op to avoid breaking existing imports.
 */

export default function AIHelperPrompt() {
  return null;
}
